export const STORE_ROLE_SETTINGS = 'adminRoleSettongsStore';
export const ARS_SET_SETTING_DATA = 'setSettingData';
export const ARS_SAVE_DATA = 'saveData';
